import { useI18n } from '@app-velocity/i18n';
import { Button, ButtonsContainer } from '@app-velocity/ui';
import { MessageBus } from '@app-velocity/message-bus';

import { useTeamAdminContext } from '../../../../context';
import { SettingsCard } from '../SettingsCard/SettingsCard';

const messageBus = new MessageBus('prototypes');

export const ReportConfig = () => {
  const { t } = useI18n();
  const { workspaceId } = useTeamAdminContext();

  const openReportConfigModal = () => {
    if (!workspaceId) return;

    messageBus.publish('modal:report-config:open', {
      workspaceId,
      mode: 'admin',
      reportType: 'figma',
    });
  };

  if (!workspaceId) return null;

  return (
    <SettingsCard
      title="teams:settings.report_config.title"
      description="teams:settings.report_config.description"
    >
      <ButtonsContainer>
        <Button
          variant="contained"
          color="primary"
          onClick={openReportConfigModal}
        >
          {t('teams:settings.report_config.open_settings')}
        </Button>
      </ButtonsContainer>
    </SettingsCard>
  );
};
